const defaultCategory = {
  name: "",
  code: "",
  poredak: null,
  parent: null,
  prilog: false,
  main_group: false,
  exclude_from_package_count: false,
};

export { defaultCategory };
